import {
  isAfter,
  isBefore,
  isSameDay,
  isSameHour,
} from 'date-fns';

export const DateOperations = {
  '=': (v: Date, v2: Date, withHour?: boolean): boolean =>
    withHour ? isSameDay(v, v2) && isSameHour(v, v2) : isSameDay(v, v2),
  '!=': (v: Date, v2: Date, withHour?: boolean): boolean =>
    withHour ? !isSameDay(v, v2) && !isSameHour(v, v2) : isSameDay(v, v2),
  '>': (v: Date, v2: Date): boolean => !isSameDay(v, v2) && isAfter(v, v2),
  '<': (v: Date, v2: Date): boolean => isBefore(v, v2),
  '>=': (v: Date, v2: Date, withHour?: boolean): boolean =>
    withHour
      ? isAfter(v, v2) || (isSameDay(v, v2) && isSameHour(v, v2))
      : isAfter(v, v2) || isSameDay(v, v2),
  '<=': (v: Date, v2: Date, withHour?: boolean): boolean =>
    withHour
      ? isBefore(v, v2) || (isSameDay(v, v2) && isSameHour(v, v2))
      : isBefore(v, v2) || isSameDay(v, v2),
};
  
export const NumberOperations = {
  '=': (v: number, v2: number): boolean => v === v2,
  '!=': (v: number, v2: number): boolean => v != v2,
  '>': (v: number, v2: number): boolean => v > v2,
  '<': (v: number, v2: number): boolean => v < v2,
  '>=': (v: number, v2: number): boolean => v >= v2,
  '<=': (v: number, v2: number): boolean => v <= v2,
};